module.exports = __webpack_public_path__ + "OpenSans-ExtraBoldItalic.24b34dbac3001596cd9a.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/OpenSans-ExtraBoldItalic.eot
// module id = ../../../../../src/assets/customfonts/OpenSans-ExtraBoldItalic.eot
// module chunks = styles